<div class="activity" [dataSelector]="'cxp-crl-panel-activity'">
  @if (showTitle()) {
    <h4 class="activity-title">Activity</h4>
  }

  @if (isLoading() && activity().length === 0) {
    <p class="activity-status" [dataSelector]="'cxp-crl-panel-activity-loading'">Loading activity…</p>
  } @else if (activity().length > 0) {
    <ul class="activity-list">
      @for (entry of activity(); track entry.id) {
        <li class="activity-row" [dataSelector]="'cxp-crl-panel-activity-row'">
          <span class="activity-avatar activity-avatar--{{ entry.avatarColorKey }}" aria-hidden="true">
            {{ entry.actorInitials }}
          </span>

          <div class="activity-main">
            <!-- Word gaps are REAL whitespace (`&ngsp;`), not margins, so a wrap at a
                 span boundary doesn't leave a leading indent on the next line. Angular
                 strips whitespace-only text nodes between elements, so `&ngsp;` is the
                 only way to emit a space that survives compilation here. -->
            <p class="activity-text">
              <span class="activity-actor">{{ entry.actorName }}</span>&ngsp;<span
                class="activity-action"
              >{{ entry.action }}</span>
              @if (entry.linkedObject) {
                &ngsp;<span
                  class="activity-link"
                  [class.activity-link--file]="entry.linkedObjectKind === 'file'"
                  [class.activity-link--muted]="entry.linkedObjectKind === 'file-deleted'"
                >{{ entry.linkedObject }}</span>
              }
            </p>

            @if (entry.files.length > 0) {
              <ul class="activity-files">
                @for (file of entry.files; track file.id) {
                  <!-- Masked rows carry `id: null` (→ 0) and `external_id: "......"`,
                       so preview/download could never resolve — render an inert chip
                       rather than buttons that silently fail. -->
                  @if (entry.isMasked) {
                    <li class="activity-file-chip activity-file-chip--masked">
                      <span class="activity-file-name" [dataSelector]="'cxp-crl-panel-activity-file-masked'">
                        <aiwyn-icon name="paperclip" class="activity-file-icon" [height]="12" [width]="12"></aiwyn-icon>
                        <span class="activity-file-label">{{ file.name }}</span>
                      </span>
                    </li>
                  } @else {
                    <li class="activity-file-chip">
                      <button
                        type="button"
                        class="activity-file-name"
                        [title]="file.name"
                        [dataSelector]="'cxp-crl-panel-activity-file-preview'"
                        (click)="previewFile.emit(file)"
                      >
                        <aiwyn-icon name="paperclip" class="activity-file-icon" [height]="12" [width]="12"></aiwyn-icon>
                        <span class="activity-file-label">{{ file.name }}</span>
                        @if (file.size !== null) {
                          <span class="activity-file-size">({{ file.size | fileSize: 1 }})</span>
                        }
                      </button>
                      <button
                        type="button"
                        class="activity-file-download"
                        aria-label="Download file"
                        [dataSelector]="'cxp-crl-panel-activity-file-download'"
                        (click)="downloadFile.emit(file)"
                      >
                        <aiwyn-icon name="download" class="icon-color-gray-400" [height]="12" [width]="12"></aiwyn-icon>
                      </button>
                    </li>
                  }
                }
              </ul>
            }

            @if (entry.comment; as comment) {
              <div
                class="activity-comment"
                [class.activity-comment--critical]="comment.isCritical"
                [dataSelector]="'cxp-crl-panel-activity-comment'"
              >
                @if (!comment.isCritical) {
                  <aiwyn-icon name="message-square" class="activity-comment-icon" [height]="12" [width]="12"></aiwyn-icon>
                }
                <span class="activity-comment-text">{{ comment.text }}</span>
              </div>
            }

            @if (entry.timestamp) {
              <span class="activity-time">{{ entry.timestamp | cxpRelativeTime }}</span>
            }
          </div>
        </li>
      }
    </ul>
  } @else {
    <p class="activity-status" [dataSelector]="'cxp-crl-panel-activity-empty'">No activity yet.</p>
  }
</div>
